<template>
    <div class="col-xl-6 box-col-6">
        <div class="widget-joins card">
          <div class="card-header pb-0">
            <h3>Order details</h3>
          </div>
          <div class="card-body">
            <div class="row gy-4">
              <div class="col-sm-6" v-for="(item,index) in menu" :key="index">
                <div class="widget-card">
                  <div class="d-flex align-self-center">
                    <div class="widget-icon" :class="item.iconClass">
                      <component :is="item.svg1"></component>
                    </div>
                    <div class="flex-grow-1">
                      <h6>{{item.title}}</h6>
                      <h5><number
                        class="bold "
                        ref="number1"
                        :from="0"
                        :to="item.count"
                        :duration="5"
                        :delay="0"
                        easing="Power1.easeOut"
                      /><span class="font-roboto  f-w-700" :class="item.fontClass"><i :class="item.icon"></i> {{item.percent}}</span></h5>
                    </div>
                  </div>
                </div>
              </div>
          
            </div>
            
          </div>
        </div>
      </div>
</template>
<script>
import {OrderDetailsData} from '../../../data/widgets/general/data'
import neworderSvg from '../general/svgPage/neworderSvg.vue'
import pendingorderSvg from '../general/svgPage/pendingorderSvg.vue'
import deliveredorderSvg from '../general/svgPage/deliveredorderSvg.vue'
import cancelledorderSvg from '../general/svgPage/cancelledorderSvg.vue'
export default{
    name: 'orderPage',
    data(){
      return{
        menu: OrderDetailsData,
        
      }
    },
    components:{
      neworderSvg,pendingorderSvg,cancelledorderSvg,deliveredorderSvg
    }
}
</script>